import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const Cyclingnews: Site = {
  id: 'cyclingnews',
  logo: 'svg/cyclingnews.svg',
  label: 'Cyclingnews',
  analyticsName: 'cyclingnews',
  hostname: 'cyclingnews.com',
  platform: 'responsive',
  selector: responsiveVanillaSelector,
};
